import { render, staticRenderFns } from "./PaymentCanceledView.vue?vue&type=template&id=a4bf9f4e&"
import script from "./PaymentCanceledView.vue?vue&type=script&lang=ts&"
export * from "./PaymentCanceledView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports